const NAME_MAX_LENGTH = 100;

export const VALIDATION_RULES = {
  NAME_MAX_LENGTH,
};

export const VALIDATION_MESSAGES = {
  NAME_MAX_LENGTH: `Client name can be no longer than ${NAME_MAX_LENGTH} characters, sorry.`,
};
